import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/performance';
import 'firebase/remote-config';

import firebaseConfig from 'config/firebase.config.js';
import remoteConfigDefault from 'config/remoteConfigDefault.config.js';

let instance = null;

class FirebaseService {
  constructor() {
    if (!instance) {
      this.app = firebase.initializeApp(firebaseConfig);
      // eslint-disable-next-line consistent-this
      instance = this;
    }
    return instance;
  }
}

const firebaseService = new FirebaseService().app;
firebaseService.analytics();
firebaseService.performance();

const remoteConfig = firebaseService.remoteConfig();
remoteConfig.defaultConfig = remoteConfigDefault;
// Without this, minimumFetchIntervalMillis defaults to 12h, so fetchAndActivate()
// keeps serving cached values and ignores Firebase console changes for up to 12
// hours (the "remote config reverts to an older version" behaviour). Fetch fresh
// each session so values like web_scenes_version reflect the console promptly.
remoteConfig.settings = {
  ...remoteConfig.settings,
  minimumFetchIntervalMillis: 0,
};

firebaseService.remoteConfig = remoteConfig;

export default firebaseService;
